import request from '../../utils/request';

export const saveNewsService = (data, id = 0) => {
  const dataToSend = {
    data,
  };
  if (id > 0) {
    
    return async dispatch => {
      const response = await dispatch(
        request('/news/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    
    const response = await dispatch(
      request('/news', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getNewssService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/news', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/news', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getNewsByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/news/' + id, {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getNewsCompleteByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/news/' + id + '/complete', {
        method: 'GET',
      }),
    );
    return response;
  };
};
export const deleteNewssService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/news', {
        method: 'DELETE',
        params: { idList: array },
      }),
    );
    
    return response;
  };
};
